import styled from 'styled-components';
import { IHeader, ITable } from '../Table';

interface ICell extends IHeader {
  isHighlighted?: boolean;
  leftAccentColor?: string;
  leftAccentBar?: boolean;
  leftAccentTint?: boolean;
  overflowVisible?: boolean;
  verticalAlign?: 'top' | 'middle' | 'bottom';
  fontSize?: ITable['fontSize'];
  isCentered?: boolean;
}

export const Cell = styled.td<ICell>`
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.palette.neutral.tableHeader};
  padding: 5px;
  ${({ isCentered }) => isCentered && 'text-align: center; vertical-align: middle;'}
  ${({ verticalAlign, isCentered }) =>
    verticalAlign && !isCentered && `vertical-align: ${verticalAlign};`}
  font-size: ${({ theme, fontSize }) =>
    fontSize === 'small'
      ? theme.textStyles.body2.fontSize
      : theme.textStyles.body.fontSize}px;
  color: ${({ theme, fontSize }) =>
    fontSize === 'small'
      ? theme.palette.text.secondary
      : theme.palette.text.primary};
  background-color: ${({
    theme,
    leftAccentTint,
    leftAccentColor,
    isHighlighted
  }) =>
    isHighlighted
      ? theme.palette.neutral.tableHighlight
      : leftAccentTint && leftAccentColor?.match(/^#[0-9a-fA-F]{6}$/)
        ? `${leftAccentColor}10`
        : theme.palette.neutral.white};
  ${({ leftAccentBar, leftAccentColor }) =>
    leftAccentBar &&
    leftAccentColor &&
    `
    box-shadow: inset 5px 0 0 0 ${leftAccentColor};
    padding-left: 10px;
  `}
  ${({ overflowVisible, isLeftFixed }) =>
    overflowVisible && !isLeftFixed && `position: relative;`}
  ${({ isLeftFixed }) => isLeftFixed && `position: sticky;`}
  ${({ isRightFixed }) => isRightFixed && `position: sticky;`}
  ${({ overflowVisible }) => overflowVisible && `overflow: visible;`}
`;
